import { call, put, takeLatest, select } from 'redux-saga/effects';
import MlClientError, { FailureOperation } from '../../../data/ml-client-error';
import { getArmAccessTokenSaga } from '../identity/access-tokens';
import { ResourceId } from '../../../utils/resource-id';
import { GalleryImageActionType } from '../../actions/gallery-image/gallery-image-actions';
import { listGalleryImagesSuccess, listGalleryImagesError, } from '../../actions/gallery-image/gallery-image-action-creators';
import LabAccountProvider from '../../../data/providers/lab-account-provider';
import { getLocale, getLanguage } from '../../selectors/common-selectors';
export function* listGalleryImages(action) {
    const { labAccountId } = action;
    try {
        const resourceId = new ResourceId(labAccountId);
        const accessToken = yield call(getArmAccessTokenSaga);
        const locale = yield select(getLocale);
        const language = yield select(getLanguage);
        const images = yield call(LabAccountProvider.listGalleryImages, resourceId, accessToken, locale, language);
        yield put(listGalleryImagesSuccess(images));
    }
    catch (e) {
        const error = new MlClientError(e ? e.message : undefined, labAccountId, FailureOperation.ListGalleryImages, e ? e.code : undefined);
        yield put(listGalleryImagesError(error));
    }
}
export function* listGalleryImagesSaga() {
    yield takeLatest(GalleryImageActionType.LIST_GALLERY_IMAGES, listGalleryImages);
}
